import type { FlagT } from './types';

export function sortFlags(a: FlagT, b: FlagT) {
  return a.displayName.localeCompare(b.displayName);
}

export function searchFlags(searchString: string) {
  return (flag: FlagT) =>
    flag.displayName.toLowerCase().includes(searchString.toLowerCase()) ||
    flag.description?.toLowerCase().includes(searchString.toLowerCase()) ||
    flag.key.toLowerCase().includes(searchString.toLowerCase());
}
